shadow$provide[192] = function(require,module,exports) {
var require$_DOT__SLASH_group_DOT_js = require("./group.js");
var require$_DOT__SLASH_inherit_DOT_js = require("./inherit.js");
var require$_DOT__SLASH_root_DOT_js = require("./root.js");
var require$_DOT__SLASH_unit_DOT_js = require("./unit.js");
require.exportCopy(module, require$_DOT__SLASH_group_DOT_js);
require.exportCopy(module, require$_DOT__SLASH_inherit_DOT_js);
require.exportCopy(module, require$_DOT__SLASH_root_DOT_js);
require.exportCopy(module, require$_DOT__SLASH_unit_DOT_js);

};